import { render } from "./classification.vue?vue&type=template&id=eec6c6ae&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"

import "./classification.vue?vue&type=style&index=0&id=eec6c6ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eec6c6ae"

export default script